'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  PORTAL: 'portalTz',
  USER: 'userTz',
  UTC: 'utc'
};
module.exports = exports['default'];